import React from 'react';

const Error = () => {
  return (
    <div className="error">
      <p>Failed to load resource: net::ERR_CONNECTION_REFUSED</p>
    </div>
  );
};

export default Error;
